export default __webpack_public_path__ + "static/media/logo-pulsehd-violet.bce20c5d.svg";